import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_tc--gray" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([$options.classList])
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(_component_base_button, {
      class: _normalizeClass(['gfu-section-expander__button','_bxsh--base', {'gfu-section-expander__button--expanded': _ctx.isExpanded}]),
      theme: "lightFlat",
      shape: "common",
      onClick: $options.changeState
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, _toDisplayString($options.buttonConfig.text), 1 /* TEXT */),
        _createVNode(_component_base_icon, {
          name: $options.buttonConfig.icon,
          class: "_tc--accent",
          size: "lg"
        }, null, 8 /* PROPS */, ["name"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["class", "onClick"])
  ], 2 /* CLASS */))
}